import { ProductSubtype } from "../Benefit/product-subtype";
import { ProductType } from "../Benefit/product-type";
import { TherapeuticClass } from "../Benefit/therapeutic-class";
import { FiscalNumber } from "../fiscal-number";
import { PriceRegime } from "./price-regime";
import { ProductUseValidity } from "./product-use-validity";
import { TributaryCreditConcession } from "./tributary-credit-concession";
import { UseType } from "./use-type";

export class ProductLabelInfo {
  private productKey: string;
  private ean1: string;
  private ean2: string;
  private ean3: string;
  private modified: string;
  private productName: string;
  private presentation: string;
  private laboratory: string;
  private productType: ProductType;
  private productSubType: ProductSubtype;
  private substance: string;
  private fiscalNumber: FiscalNumber;
  private GGREMCode: string;
  private registry: string;
  private therapeuticClass: TherapeuticClass;
  private productUseValidity: ProductUseValidity;
  private priceRegime: PriceRegime;
  private hospitalRestriction: boolean;
  private cap: boolean;
  private confaz: boolean;
  private icms0Percent: boolean;
  private appealAnalysis: string;
  private tributaryCreditConcession: TributaryCreditConcession;
  private commercialization: boolean;
  private targe: string;
  private useType: UseType;

  public getProductKey(): string {
    return this.productKey;
  }

  public setProductKey(value: string): void {
    this.productKey = value;
  }

  public getEan1(): string {
    return this.ean1;
  }

  public setEan1(value: string): void {
    this.ean1 = value;
  }

  public getEan2(): string {
    return this.ean2;
  }

  public setEan2(value: string): void {
    this.ean2 = value;
  }

  public getEan3(): string {
    return this.ean3;
  }

  public setEan3(value: string): void {
    this.ean3 = value;
  }

  public getModified(): string {
    return this.modified;
  }

  public setModified(modified: string): void {
    this.modified = modified;
  }

  public getProductName(): string {
    return this.productName;
  }

  public setProductName(value: string): void {
    this.productName = value;
  }

  public getPresentation(): string {
    return this.presentation;
  }

  public setPresentation(value: string): void {
    this.presentation = value;
  }

  public getLaboratory(): string {
    return this.laboratory;
  }

  public setLaboratory(value: string): void {
    this.laboratory = value;
  }

  public getProductType(): ProductType {
    return this.productType;
  }

  public setProductType(value: ProductType): void {
    this.productType = value;
  }

  public getProductSubType(): ProductSubtype {
    return this.productSubType;
  }

  public setProductSubType(value: ProductSubtype): void {
    this.productSubType = value;
  }

  public getSubstance(): string {
    return this.substance;
  }

  public setSubstance(value: string): void {
    this.substance = value;
  }

  public getFiscalNumber(): FiscalNumber {
    return this.fiscalNumber;
  }

  public setFiscalNumber(value: FiscalNumber): void {
    this.fiscalNumber = value;
  }

  public getGGREMCode(): string {
    return this.GGREMCode;
  }

  public setGGREMCode(value: string): void {
    this.GGREMCode = value;
  }

  public getRegistry(): string {
    return this.registry;
  }

  public setRegistry(value: string): void {
    this.registry = value;
  }

  public getTherapeuticClass(): TherapeuticClass {
    return this.therapeuticClass;
  }

  public setTherapeuticClass(value: TherapeuticClass): void {
    this.therapeuticClass = value;
  }

  public getProductUseValidity(): ProductUseValidity {
    return this.productUseValidity;
  }

  public setProductUseValidity(value: ProductUseValidity): void {
    this.productUseValidity = value;
  }

  public getPriceRegime(): PriceRegime {
    return this.priceRegime;
  }

  public setPriceRegime(value: PriceRegime): void {
    this.priceRegime = value;
  }

  public getHospitalRestriction(): boolean {
    return this.hospitalRestriction;
  }

  public setHospitalRestriction(value: boolean): void {
    this.hospitalRestriction = value;
  }

  public getCap(): boolean {
    return this.cap;
  }

  public setCap(value: boolean): void {
    this.cap = value;
  }

  public getConfaz(): boolean {
    return this.confaz;
  }

  public setConfaz(value: boolean): void {
    this.confaz = value;
  }

  public getIcms0Percent(): boolean {
    return this.icms0Percent;
  }

  public setIcms0Percent(value: boolean): void {
    this.icms0Percent = value;
  }

  public getAppealAnalysis(): string {
    return this.appealAnalysis;
  }

  public setAppealAnalysis(value: string): void {
    this.appealAnalysis = value;
  }

  public getTributaryCreditConcession(): TributaryCreditConcession {
    return this.tributaryCreditConcession;
  }

  public setTributaryCreditConcession(value: TributaryCreditConcession): void {
    this.tributaryCreditConcession = value;
  }

  public getCommercialization(): boolean {
    return this.commercialization;
  }

  public setCommercialization(value: boolean): void {
    this.commercialization = value;
  }

  public getTarge(): string {
    return this.targe;
  }

  public setTarge(value: string): void {
    this.targe = value;
  }

  public getUseType(): UseType {
    return this.useType;
  }

  public setUseType(value: UseType): void {
    this.useType = value;
  }
}
